export default __webpack_public_path__ + "1cb5cad4358c44d530ae057f6c12cf6b.svg";